"use strict";
exports.__esModule = true;
exports.SpacingXxl = exports.SpacingXl = exports.SpacingL = exports.SpacingM = exports.SpacingBase = exports.SpacingS = exports.SpacingXs = exports.SpacingMicro = void 0;
exports.SpacingMicro = "4px";
exports.SpacingXs = "8px";
exports.SpacingS = "12px";
exports.SpacingBase = "16px";
exports.SpacingM = "20px";
exports.SpacingL = "24px";
exports.SpacingXl = "32px";
exports.SpacingXxl = "40px";
